import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/ui-common/src/IconButton/IconButton.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
export var IconButtonStyled = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: max-content;\n  width: max-content;\n  position: relative;\n  border: none;\n  cursor: pointer;\n  background: transparent;\n  border-radius: 4px;\n  transition: all 0.2s ease-out;\n  padding: ", ";\n  ", "\n  ", "\n  ", "\n\n  & svg {\n    ", "\n  }\n\n  path {\n    transition: all 0.2s ease-out;\n    fill: rgba(53, 59, 96, 0.5);\n    ", ";\n  }\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:active {\n    ", "\n  }\n\n  &:disabled {\n    pointer-events: none;\n    background: inherit;\n    cursor: default;\n\n    path {\n      fill: rgba(53, 59, 96, 0.15);\n    }\n  }\n"])), function (props) {
  return props.size === 'xs' ? '0' : props.size === 'small' ? '4px' : '6px';
}, function (props) {
  return props.isCircle && 'border-radius: 50%;';
}, function (props) {
  return props.active && 'background: rgba(53, 59, 96, 0.2);';
}, function (props) {
  return props.selected && 'background: #4C5ECF;';
}, function (props) {
  return props.size === 'xs' ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            width: 20px;\n            min-width: 20px;\n            height: 20px;\n            min-height: 20px;\n          "]))) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            width: 24px;\n            min-width: 24px;\n            height: 24px;\n            min-height: 24px;\n          "])));
}, function (props) {
  return props.selected && 'fill: #fff;';
}, function (props) {
  return props.selected ? '#2235AA' : 'rgba(53, 59, 96, 0.1)';
}, function (props) {
  return !props.selected && 'background: rgba(53, 59, 96, 0.2)';
});
export var WarningButton = styled(IconButtonStyled)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n\n  & path {\n    fill: ", ";\n  }\n\n  &:hover {\n    ", "\n  }\n\n  &:active {\n    ", "\n  }\n"])), function (props) {
  return props.selected ? 'background: rgb(217, 87, 94);' : '';
}, function (props) {
  return props.selected ? '#fff' : 'rgb(217, 87, 94)';
}, function (props) {
  return props.selected ? 'background: rgb(191, 55, 55);' : '';
}, function (props) {
  return props.selected ? 'background: rgb(217, 87, 94);' : '';
});